import { useTranslation } from "react-i18next";
import { CheckCircleIcon } from "@heroicons/react/24/solid";

export default function ExternalExamResult() {
  const { t } = useTranslation();

  const handleGoBack = () => {
    const PORTAL_URL =
      sessionStorage.getItem("portalUrl") ?? process.env.REACT_APP_BILORG_URL;

    if (PORTAL_URL) {
      window.location.href = PORTAL_URL;
    } else {
      window.history.back();
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4 py-8">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-6 text-center shadow-sm motion-safe:animate-fade-in sm:p-10">
        <span className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-emerald-50 ring-8 ring-emerald-50/50">
          <CheckCircleIcon className="h-10 w-10 text-emerald-500" />
        </span>
        <h2 className="mb-2 text-xl font-semibold tracking-tight text-slate-900">
          {t("exam_taking.external_submit_success")}
        </h2>
        <p className="mb-8 text-sm leading-6 text-slate-500">
          {t("exam_taking.external_submit_description")}
        </p>
        <button
          onClick={handleGoBack}
          className="inline-flex h-11 w-full items-center justify-center gap-2 rounded-lg bg-blue-600 px-5 text-sm font-medium text-white shadow-sm shadow-blue-600/25 transition duration-200 hover:bg-blue-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 sm:w-auto"
        >
          {t("exam_taking.go_back")}
        </button>
      </div>
    </div>
  );
}
